// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";

import { isCountryPerformanceRow } from "../engagementAppGroupIdCampaignCountryPerformanceCampaignId/validators";

export const isGetEngagementAppGroupIdCanvasCountryPerformanceWorkflowIdResult = objectOf({
  country_performance: arrayOf(isCountryPerformanceRow),
});
